module.exports = __webpack_public_path__ + "fonts/HelveticaNeue.a7de7e96.eot";